<template>
<div class="container-fluid">
  <h3 style="margin: 25px">Terapeutas</h3>

  <b-row style="margin: 25px">
    <b-col sm="1">
      <label class="filter-label">Filtrar busca</label>
    </b-col>
    
    <b-col md="2">
      <b-form-select class="form-select" :options="stateOptions" @change="listCities" v-model="selectedState">
        <template #first>
          <b-form-select-option :value="''" disabled>Selecione o estado</b-form-select-option>
          <b-form-select-option :value="null"></b-form-select-option>
        </template>
      </b-form-select>
    </b-col>

    <b-col md="2">
      <b-form-select 
        class="form-select" 
        :disabled="!(cityOptions && cityOptions.length)" 
        :options="cityOptions" 
        v-model="selectedCity"
      >
        <template #second>
          <b-form-select-option :value="''" disabled>Selecione a cidade</b-form-select-option>
          <b-form-select-option :value="null"></b-form-select-option>
        </template>
      </b-form-select>
    </b-col>

    <b-col md=2>
      <b-button @click="filterTherapists" type="success">Filtrar</b-button>
    </b-col>
  
  </b-row>

  <b-row style="margin: 25px">
    <b-col>
      <img :src="loadingSpinner" alt="Loading..." v-if="isLoading"/>

      <h3 v-else-if="this.therapists.length === 0">Não foi encontrado nenhum terapeuta...</h3>

      <div v-else class="row row-cols-md-8" style="margin: 20px 50px 0px 0px;">
        <therapist-card
          v-for="therapist in therapists" 
          :key="therapist.id" 
          :therapist="therapist"
          @therapistDeleted="fetchTherapists" 
        >
        </therapist-card>
      </div>

    </b-col>
  </b-row>
  
  <app-footer />
</div>
</template>

<script>
import TherapistCard from '../components/TherapistCard.vue';
import * as therapistsApiClient from '../js/therapistsApiClient'
import geoApiClient from '../js/geoApiClient'
import loadingSpinner from '../assets/images/Spinner-0.8s-200px.gif'
import AppFooter from '../components/AppFooter.vue'
import Vue from "vue";

export default {
  name: 'Therapists',
  components: { TherapistCard, AppFooter },
  data: function() {
    return {
      isLoading: false,
      therapists: [],
      selectedState: '',
      selectedCity: '',
      stateOptions: [],
      cityOptions: [],
      loadingSpinner,
    }
  },
  async mounted() {
    this.fetchTherapists();
    this.listStateOptions();
  },
  methods: {
    async fetchTherapists() {
      this.isLoading = true;
      const listTherapistsResponse = await therapistsApiClient.listTherapists();
      
      if (listTherapistsResponse.success) {
        this.therapists = listTherapistsResponse.data;
      }
      else {
        Vue.$toast.error(`Erro ao buscar terapeutas: ${listTherapistsResponse.message}`)
      }
      
      this.isLoading = false;
    },
    async listStateOptions() {
      this.selectedState = '';
      try {
          this.stateOptions = await geoApiClient.listBrazilianStatesNamesAsync(true);
      }
      catch (err) {
          Vue.$toast.error(`Erro ao listar estados: ${err.message}`);
      }
    },
    async listCities() {
      this.cityOptions = [];
      this.selectedCity = '';

      if (this.selectedState) {
        try {
            this.cityOptions = await geoApiClient.listBrazilianCitiesNamesAsync(this.selectedState, true)
        }
        catch (err) {
            Vue.$toast.error(`Erro ao listar cidades: ${err.message}`);
        }
      }
    },
    async filterTherapists() {
      
      this.isLoading = true;
      
      const getFilteredTherapistsResponse = await therapistsApiClient.listTherapists(this.selectedState, this.selectedCity);
      
      if (getFilteredTherapistsResponse.success) {
        this.therapists = getFilteredTherapistsResponse.data;
      }
      else {
        Vue.$toast.error(`Erro ao filtrar terapeutas: ${getFilteredTherapistsResponse.message}`);
      }

      this.isLoading = false;
    }
  }
}

</script>

<style scoped>

.filter-label {
  text-align: center;
  text-justify: auto;
}

.scrollable-area {
  overflow-y: scroll;
  height: 100%;
}

</style>
